export const AdditionalDocuments = [
    'T1032_P', 'T1032_S', 'T1135_P', 'T1135_S',
    'T2091_P', 'T2091_S', 'T2202_P', 'T2202_S',
    'POMA_P', 'POMA_S', 'POMQCA_P', 'POMQCA_S'
];